const analytics = {
  track: (...args: any[]): void => (window as any).analytics && (window as any).analytics.track(...args),
  page: (...args: any[]): void => (window as any).analytics && (window as any).analytics.page(...args),
  init: (segmentKey: string): void => (window as any).analytics.load(segmentKey)
};

export default analytics;
